import React, { useEffect, useState } from "react";
import { Button, Modal, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import {
	deleteAdmin,
	fetchAdmin,
	updateAdmin,
	fetchAdmins,
} from "../../actions/admin";

import "./Question.scss";
import { DateTimeFormat } from "../../helpers/utils";
import { ReactSVG } from "react-svg";
import { Link, useHistory } from "react-router-dom";
import AdminForm from "../Forms/Admin";
import { PAGE_SIZE } from "../../constants";

const AdminPage = () => {
	const { id } = useParams();
	const history = useHistory();
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [adminId, setAdminId] = useState(null);
	const { status, admin } = useSelector((state) => state.fetchAdmin);
	const { status: updateStatus } = useSelector((state) => state.updateAdmin);
	const { adminDeleted } = useSelector((state) => state.deleteAdmin);

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
	};

	const handleEdit = () => {
		showModal();
		setAdminId(admin.id);
		form.setFieldsValue(admin);
	};

	const handleDelete = () => {
		dispatch(deleteAdmin(admin.id));
	};

	const handleSubmitForm = (values) => {
		if (adminId) {
			dispatch(updateAdmin(adminId, values));
		}
		handleOk();
	};

	useEffect(() => {
		if (status === "IDLE") {
			dispatch(fetchAdmin(id));
		}
	}, [status]);

	useEffect(() => {
		if (updateStatus === "SUCCEEDED") dispatch(fetchAdmin(id));
	}, [updateStatus]);

	useEffect(() => {
		if (adminDeleted) {
			dispatch(fetchAdmins({ start: 0, count: PAGE_SIZE }));
			history.push("/admins");
		}
	}, [adminDeleted]);

	return (
		<div id="question-container">
			<div className="page-header">
				<h2 className="page-header-title">Admin Details</h2>
			</div>
			<div className="page-header-details-actions">
				<div className="left">
					<Link to="/admins">
						<Button type="link" className="btn btn-back">
							<ReactSVG src="/icons/arrow-left.svg" />
							Back
						</Button>
					</Link>
				</div>
				<div className="right">
					<Button
						type="primary"
						className="btn-primary"
						onClick={() => handleEdit()}
					>
						Edit
						<ReactSVG src="/icons/edit.svg" />
					</Button>
					<Button className="btn btn-danger" onClick={() => handleDelete()}>
						Delete
						<ReactSVG src="/icons/delete-all.svg" />
					</Button>
				</div>
			</div>
			{status === "SUCCEEDED" && (
				<div className="page-content">
					<div className="page-details-section">
						<div>
							<div className="box">
								<div className="box-header">
									<h2 className="box-title">Details</h2>
								</div>
								<div className="box-content">
									<div className="details-item">
										<label>Email</label>
										<div className="text" style={{ textTransform: "initial" }}>
											{admin.email}
										</div>
									</div>
									<div className="details-item">
										<label>Role</label>
										<div className="text">
											{admin.role === "super_admin"
												? "Super Admin"
												: admin.role}
										</div>
									</div>
									<div className="details-item">
										<label>Updated At</label>
										<div className="text">
											{DateTimeFormat(admin.updated_at)}
										</div>
									</div>
									<div className="details-item">
										<label>Created At</label>
										<div className="text">
											{DateTimeFormat(admin.created_at)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
			<Modal
				className="add-category-modal"
				visible={isModalVisible}
				onOk={handleOk}
				onCancel={handleCancel}
				footer={null}
			>
				<AdminForm
					form={form}
					adminId={adminId}
					handleSubmitForm={handleSubmitForm}
					handleCancel={handleCancel}
				/>
			</Modal>
		</div>
	);
};

export default AdminPage;
